export interface PricingPlan {
  readonly name: string;
  readonly price: string;
  readonly chip: string;
  readonly features: readonly string[];
  readonly homepageFeatures: readonly string[];
}

// Launch prices are USD until Booply adds localisation.
export const PRICING_PLANS = [
  {
    name: "Free",
    price: "$0",
    chip: "Start",
    features: [
      "Create up to 3 active Spaces at any given time",
      "Join unlimited Spaces",
      "10 members per Space",
      "2 Rooms per Space",
      "Messages clear after a week",
      "QR/code/link joining",
      "Member approval",
      "Standard Relay",
      "Basic recovery"
    ],
    homepageFeatures: [
      "3 active Free Spaces",
      "10 members",
      "2 Rooms",
      "Messages clear after a week"
    ]
  },
  {
    name: "Plus",
    price: "$3.99/month",
    chip: "Personal",
    features: [
      "Create up to 10 active personal Spaces",
      "15 members per Plus Space",
      "3 Rooms per Space",
      "Enhanced encrypted recovery",
      "Reserved handle",
      "Priority Relay for eligible Spaces",
      "Search within retained messages",
      "Supporter badge"
    ],
    homepageFeatures: [
      "10 active personal Spaces",
      "15 members",
      "3 Rooms",
      "Messages clear after a week"
    ]
  },
  {
    name: "Spaces 1",
    price: "$12.99/month",
    chip: "Paid Space slot",
    features: [
      "1 paid Space slot",
      "25 members",
      "8 Rooms",
      "Role-based Rooms",
      "Verified Space",
      "Guest Passes",
      "QR posters",
      "Choose a week, two weeks or a month",
      "Report Review Queue",
      "Priority Relay"
    ],
    homepageFeatures: [
      "1 paid Space slot",
      "25 members and 8 Rooms",
      "Choose a week, two weeks or a month",
      "Paid admin controls"
    ]
  },
  {
    name: "Spaces 3",
    price: "$38.99/month",
    chip: "3 paid slots",
    features: [
      "3 paid Space slots",
      "All Spaces 1 features for each assigned Space",
      "Each slot assigned to one owned Space",
      "25 members per paid Space",
      "8 Rooms per paid Space",
      "Role-based Rooms",
      "Guest Passes",
      "QR posters",
      "Choose a week, two weeks or a month",
      "Priority Relay"
    ],
    homepageFeatures: [
      "3 paid Space slots",
      "25 members per paid Space",
      "8 Rooms per paid Space",
      "Paid admin controls"
    ]
  }
] as const satisfies readonly PricingPlan[];

export const PRICING_FAQS = [
  {
    question: "Can anyone join unlimited Spaces?",
    answer: "Yes. Joining is separate from creating Spaces. Any user can join unlimited Spaces, subject to admin approval and fair-use limits."
  },
  {
    question: "Do paid Spaces count against my personal Space limit?",
    answer: "No. Paid Spaces assigned to paid Space slots do not count against your Free or Plus personal Space creation limit."
  },
  {
    question: "What happens if I cancel?",
    answer: "Paid features continue until the end of the billing period. If a paid Space later exceeds Free limits, it enters Free Limit Mode with a 14-day grace period."
  },
  {
    question: "How long do messages stay?",
    answer: "Messages clear after a week by default. Paid Spaces can choose a week, two weeks or a month."
  },
  {
    question: "Does Booply require a phone number?",
    answer: "No. Booply does not require phone numbers and does not upload contacts."
  },
  {
    question: "What kinds of groups is Booply for?",
    answer: "Booply is built for organisers, clubs, teams, events and communities that need private Spaces, approval and operational Rooms."
  },
  {
    question: "Does Booply support media?",
    answer: "No. Booply is text-only by design and does not support media messages."
  },
  {
    question: "Can I buy several paid Spaces?",
    answer: "Yes. Spaces 1 gives you one paid Space slot. Spaces 3 gives you three. Each slot can be assigned to one Space you own."
  }
] as const;
